export default {
    title: 'Schránka',
    empty: 'Schránka je prázdná. Přidejte QR z editace sady, zařízení nebo zóny.',
    print: 'Tisknout arch',
    clear: 'Vyprázdnit',
    remove: 'Odebrat',
    split: 'Rozpojit',
    addPage: 'Přidat stránku',
    urlInQr: 'URL do QR kódu',
    dragHandle: 'Přesunout (tažením)',
    pageBreak: {
        placeholder: 'Stránka {n}',
        remove: 'Odebrat stránku',
        empty: 'Prázdná stránka'
    },
    merge: {
        deniedKindMismatch: 'Nelze sloučit (různé typy)',
        deniedSameLogin: 'Nelze sloučit dva loginy',
        success: 'Kódy sloučeny',
        loginAttached: 'Login připojen'
    },
    printLabel: {
        add: 'Přidat vlastní popisek',
        placeholder: 'Vlastní popisek pro tisk',
        hint: 'Při tisku se použije místo výčtu názvů'
    },
    service: {
        addButton: 'Servisní kód',
        addedToast: '+1 do schránky: {label}',
        modal: {
            title: 'Servisní QR kódy',
            close: 'Zavřít'
        },
        groups: {
            reader: 'Nastavení čtečky',
            scanner: 'Nastavení skeneru',
            hwOnlyBadge: 'jen HW čtečka'
        },
        hwOnlyCard: 'Funguje jen na HW čtečce',
        // V katalog modalu se používají sekce s nadpisem (heading) + dlaždice s krátkou
        // variantou (short). Karta ve schránce a tisk používají plné labely (prod = 'SERVER prod').
        server: {
            heading: 'SERVER',
            prod: 'SERVER prod',
            test: 'SERVER test',
            short: { prod: 'produkční', test: 'testovací' },
            subtitle: 'Přepne čtečku na produkční / testovací server'
        },
        counter: {
            heading: 'COUNTER',
            on: 'COUNTER zapnuto',
            off: 'COUNTER vypnuto',
            short: { on: 'zapnuto', off: 'vypnuto' },
            subtitle: 'Počítadlo naskenovaných lístků v UI'
        },
        display: {
            heading: 'DISPLAY',
            label: 'DISPLAY {pct} %',
            short: '{pct} %',
            subtitle: 'Jas displeje čtečky'
        },
        // Název jazyka je přeložený do aktuální lokalizace (exonym).
        language: {
            heading: 'LANGUAGE',
            cs: 'LANGUAGE čeština',
            en: 'LANGUAGE angličtina',
            sk: 'LANGUAGE slovenština',
            de: 'LANGUAGE němčina',
            pl: 'LANGUAGE polština',
            hu: 'LANGUAGE maďarština',
            hr: 'LANGUAGE chorvatština',
            short: {
                cs: 'čeština',
                en: 'angličtina',
                sk: 'slovenština',
                de: 'němčina',
                pl: 'polština',
                hu: 'maďarština',
                hr: 'chorvatština'
            },
            subtitle: 'Přepne jazyk UI'
        },
        scanInfo: {
            heading: 'SCAN-INFO',
            none: 'SCAN-INFO nic',
            price: 'SCAN-INFO cena',
            ticketset: 'SCAN-INFO sada',
            'ticketset-price': 'SCAN-INFO sada + cena',
            short: {
                none: 'nic nezobrazovat',
                price: 'jen cena',
                ticketset: 'jen sada',
                'ticketset-price': 'sada a cena'
            },
            subtitle: 'Co se zobrazí po naskenování lístku'
        },
        wifi: {
            heading: 'WIFI',
            tile: 'WIFI',
            expandHint: 'Klikni a vyplň SSID + heslo',
            ssidLabel: 'SSID',
            passwordLabel: 'Heslo',
            addBtn: 'Přidat do schránky',
            label: 'WIFI: {ssid}',
            subtitle: 'Připojení k Wi-Fi síti'
        },
        startUpdate: {
            heading: 'START-UPDATE',
            label: 'Aktualizace firmware',
            short: 'spustit',
            subtitle: 'Spustí update čtečky'
        },
        reset: {
            heading: 'RESET',
            label: 'Tovární reset ⚠',
            short: 'tovární reset ⚠',
            subtitle: 'Smaže veškerá nastavení čtečky'
        }
    }
}
